import { Link } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbDivider,
  BreadcrumbSection,
  Container,
} from "semantic-ui-react";
import EditUser from "../components/sidekick/users/EditUser";

function UserDetails() {
  return (
    <Container
      style={{
        margin: "20px 0px",
        display: "flex",
        gap: "25px",
        flexDirection: "column",
      }}
    >
      <Breadcrumb>
        <BreadcrumbSection>Admin</BreadcrumbSection>
        <BreadcrumbDivider />
        <BreadcrumbSection>
          <Link to="/users">Users</Link>
        </BreadcrumbSection>
        <BreadcrumbDivider icon="right angle" />
        <BreadcrumbSection active>Edit User</BreadcrumbSection>
      </Breadcrumb>

      <EditUser />
    </Container>
  );
}

export default UserDetails;
